import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: '',
		meta: {
			appname: 'GBWhatsApp',
			title: `Snapinsta – Download Instagram Reels, Video, Story, Photo, IGTV Online`,
			keywords: 'snapinsta, snapinsta app, snapinsta download, snapinsta downloader',
			description: `SnapInsta platform that allows you to effortlessly download Instagram reels, videos, stories, and photos with just a few clicks`,
			link: [
				{
					rel: 'canonical',
					href: `https://snapsinsta.com/`,
				},
			],
		},
		component: () => import('@/views/home.vue'),
	},
	{
		path: '/instagram-viewer/',
		name: 'instagram-viewer',
		meta: {
			appname: 'SnapInsta',
			title: 'Instagram Viewer – View Public Instagram Posts Online',
			keywords: 'instagram viewer, instagram profile viewer, view instagram online',
			description: 'Preview public Instagram posts and Reels in your browser. Paste a link to supported public content—private profiles are not available.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/instagram-viewer/' }],
		},
		component: () => import('@/views/instagram-viewer.vue'),
	},
	{
		path: '/instagram-photo-downloader/',
		name: 'instagram-photo-downloader',
		meta: {
			appname: 'SnapInsta',
			title: 'Instagram Photo Downloader – Save Public Instagram Images',
			keywords: 'instagram photo downloader, download instagram photos, instagram image downloader',
			description: 'Download photos from public Instagram posts and carousels. Paste the post link, preview available images, and save to your device.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/instagram-photo-downloader/' }],
		},
		component: () => import('@/views/instagram-photo-downloader.vue'),
	},
	{
		path: '/instagram-story-downloader/',
		name: 'instagram-story-downloader',
		meta: {
			appname: 'SnapInsta',
			title: 'Instagram Story Downloader – Save Stories While Available',
			keywords: 'instagram story downloader, download instagram story',
			description: 'Save public Instagram Story photos or videos when you have a working link. Stories expire—public links only.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/instagram-story-downloader/' }],
		},
		component: () => import('@/views/instagram-story-downloader.vue'),
	},
	{
		path: '/instagram-reels-downloader/',
		name: 'instagram-reels-downloader',
		meta: {
			appname: 'SnapInsta',
			title: 'Instagram Reels Downloader – Download Public Reels',
			keywords: 'instagram reels downloader, download instagram reels',
			description: 'Download public Instagram Reels with the Reel link. Preview the video and save the file when Instagram makes it available.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/instagram-reels-downloader/' }],
		},
		component: () => import('@/views/instagram-reels-downloader.vue'),
	},
	{
		path: '/instagram-igtv-downloader/',
		name: 'instagram-igtv-downloader',
		meta: {
			appname: 'SnapInsta',
			title: 'Instagram IGTV Downloader – Legacy Long-Form Video Links',
			keywords: 'instagram igtv downloader, download igtv video',
			description: 'Try to download older IGTV or /tv/ links when content is still public. IGTV merged into Instagram Video in 2021.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/instagram-igtv-downloader/' }],
		},
		component: () => import('@/views/instagram-igtv-downloader.vue'),
	},
	{
		path: '/is-it-safe-to-use-snapinsta/',
		name: 'is-it-safe-to-use-snapinsta',
		meta: {
			appname: 'GBWhatsApp',
			title: `Is It Safe to Use SnapInsta?`,
			keywords: 'is it safe to use SnapInsta',
			description: `SnapInsta enables quick Instagram downloads without login, offering convenience, but users should consider privacy, malware, and copyright risks before using it.`,
			link: [
				{
					rel: 'canonical',
					href: `https://snapsinsta.com/is-it-safe-to-use-snapinsta/`,
				},
			],
		},
		component: () => import('@/views/blog-1.vue'),
	},
	{
		path: '/where-do-instagram-downloads-go-on-iphone/',
		name: 'where-do-instagram-downloads-go-on-iphone',
		meta: {
			appname: 'SnapInsta',
			title: 'Where Do Instagram Downloads Go on iPhone? Find Them Fast',
			keywords: 'where do instagram downloads go on iphone, instagram downloads iphone',
			description: `Can't find an Instagram photo or video you downloaded on iPhone? Learn where Safari and Chrome save downloads and how to move them to Photos.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/where-do-instagram-downloads-go-on-iphone/',
				},
			],
		},
		component: () => import('@/views/where-do-instagram-downloads-go-on-iphone.vue'),
	},
	{
		path: '/how-to-download-all-photos-from-instagram-carousel/',
		name: 'how-to-download-all-photos-from-instagram-carousel',
		meta: {
			appname: 'SnapInsta',
			title: 'How to Download All Photos from an Instagram Carousel',
			keywords: 'download instagram carousel photos, instagram carousel downloader',
			description: 'Want to save every photo from an Instagram carousel? Learn how to copy the right post link, download multiple images, and find them on your phone.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/how-to-download-all-photos-from-instagram-carousel/',
				},
			],
		},
		component: () => import('@/views/how-to-download-all-photos-from-instagram-carousel.vue'),
	},
	{
		path: '/why-is-my-instagram-download-blurry/',
		name: 'why-is-my-instagram-download-blurry',
		meta: {
			appname: 'SnapInsta',
			title: 'Why Is My Instagram Download Blurry? Causes & Fixes',
			keywords: 'instagram download blurry, blurry instagram video download',
			description: 'Is your Instagram photo or video blurry after downloading? Learn why it happens, how to check file quality, and how to get the best available version.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/why-is-my-instagram-download-blurry/',
				},
			],
		},
		component: () => import('@/views/why-is-my-instagram-download-blurry.vue'),
	},
	{
		path: '/how-to-download-instagram-photos-without-taking-a-screenshot/',
		name: 'how-to-download-instagram-photos-without-taking-a-screenshot',
		meta: {
			appname: 'SnapInsta',
			title: 'How to Download Instagram Photos Without Taking a Screenshot',
			keywords: 'download instagram photos, save instagram photos',
			description: 'Learn when downloading beats screenshots, how to save carousel photos, and what to expect for image quality on iPhone and Android.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/how-to-download-instagram-photos-without-taking-a-screenshot/' }],
		},
		component: () => import('@/views/how-to-download-instagram-photos-without-taking-a-screenshot.vue'),
	},
	{
		path: '/how-to-download-instagram-stories-before-they-disappear/',
		name: 'how-to-download-instagram-stories-before-they-disappear',
		meta: {
			appname: 'SnapInsta',
			title: 'How to Download Instagram Stories Before They Disappear',
			keywords: 'download instagram story, save instagram stories',
			description: 'Stories expire quickly. Practical steps to copy a Story link, save photos or videos, and understand what you cannot access.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/how-to-download-instagram-stories-before-they-disappear/' }],
		},
		component: () => import('@/views/how-to-download-instagram-stories-before-they-disappear.vue'),
	},
	{
		path: '/how-to-download-instagram-reels-to-your-phone/',
		name: 'how-to-download-instagram-reels-to-your-phone',
		meta: {
			appname: 'SnapInsta',
			title: 'How to Download Instagram Reels to Your Phone',
			keywords: 'download instagram reels, save reels to phone',
			description: 'Step-by-step help to copy a Reel link, download on Android or iPhone, and understand audio and copyright limits.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/how-to-download-instagram-reels-to-your-phone/' }],
		},
		component: () => import('@/views/how-to-download-instagram-reels-to-your-phone.vue'),
	},
	{
		path: '/instagram-story-vs-reels-whats-the-difference/',
		name: 'instagram-story-vs-reels-whats-the-difference',
		meta: {
			appname: 'SnapInsta',
			title: "Instagram Story vs Reels: What's the Difference?",
			keywords: 'instagram story vs reels, stories or reels',
			description: 'Compare Stories and Reels by purpose, lifespan, and format so you pick the right one—and know how to save each.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/instagram-story-vs-reels-whats-the-difference/' }],
		},
		component: () => import('@/views/instagram-story-vs-reels-whats-the-difference.vue'),
	},
	{
		path: '/what-happened-to-instagram-igtv/',
		name: 'what-happened-to-instagram-igtv',
		meta: {
			appname: 'SnapInsta',
			title: 'What Happened to Instagram IGTV? Guide to Old Videos',
			keywords: 'instagram igtv, what happened to igtv',
			description: 'IGTV merged into Instagram Video in 2021. Learn why old links break and how to try downloading legacy /tv/ URLs.',
			link: [{ rel: 'canonical', href: 'https://snapsinsta.com/what-happened-to-instagram-igtv/' }],
		},
		component: () => import('@/views/what-happened-to-instagram-igtv.vue'),
	},
	{
		path: '/blog/',
		name: 'blogs',
		meta: {
			appname: 'GBWhatsApp',
			title: `Blogs to Help You Use SnapInsta Video Downloader`,
			keywords: 'SnapInsta Blogs',
			description: `We update blogs about SnapInsta Instagram Video Downloader. If you need guide or hope to learn some topics about this tool, you can read our blogs.`,
			link: [
				{
					rel: 'canonical',
					href: `https://snapsinsta.com/blog/`,
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/test',
		alias: '/test/',
		name: 'test',
		meta: {
			appname: 'SnapInsta',
			title: 'SnapInsta Test',
			keywords: 'snapinsta test',
			description: 'SnapInsta service test page',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/test'
				}
			]
		},
		component: () => import('@/views/test.vue'),
	},
	// {
	// 	path: '/download',
	// 	name: 'en-download',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		title: `Download Page: GB WhatsApp APK Latest Version Updated`,
	// 		keywords: 'gbwhatsapp apk download, gb whatsapp apk download, gbwhatsapp download, gb whatsapp download',
	// 		description: `Download the latest GB WhatsApp APK 2026 – updated, safe, and anti-ban. Enjoy advanced privacy, custom themes, status download, and more on Android.`,
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://snapsinsta.com/download/'
	// 			}
	// 		]
	// 	},
	// 	component: () => import('@/views/download.vue'),
	// },
	{
		path: '/privacy/',
		name: 'privacy-policy',
		meta: {
			appname: 'SnapInsta',
			title: 'Privacy Policy - SnapInsta',
			keywords: 'snapinsta privacy policy',
			description: 'Learn what information may be collected when you use SnapInsta and how that information may be used.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/privacy/',
				},
			],
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/terms/',
		name: 'terms-of-use',
		meta: {
			appname: 'SnapInsta',
			title: 'Terms of Use - SnapInsta',
			keywords: 'snapinsta terms of use',
			description: 'Read the terms that apply when you access or use SnapInsta.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/terms/',
				},
			],
		},
		component: () => import('@/views/terms.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			appname: 'SnapInsta',
			title: 'Disclaimer - SnapInsta',
			keywords: 'snapinsta disclaimer',
			description: 'Read the SnapInsta service and user responsibility disclaimer.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/disclaimer/',
				},
			],
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/dmca/',
		name: 'dmca',
		meta: {
			appname: 'SnapInsta',
			title: 'DMCA & Copyright Policy - SnapInsta',
			keywords: 'snapinsta dmca, snapinsta copyright policy',
			description: 'Learn how to submit a copyright complaint or request related to SnapInsta.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/dmca/',
				},
			],
		},
		component: () => import('@/views/dmca.vue'),
	},
	{
		path: '/about/',
		name: 'about',
		meta: {
			appname: 'SnapInsta',
			title: 'About - SnapInsta',
			keywords: 'about snapinsta',
			description: 'Learn more about SnapInsta and the service it provides.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/about/',
				},
			],
		},
		component: () => import('@/views/about.vue'),
	},
	{
		path: '/contact/',
		name: 'contact',
		meta: {
			appname: 'SnapInsta',
			title: 'Contact Us - SnapInsta',
			keywords: 'contact snapinsta',
			description: 'Contact SnapInsta for questions, feedback, copyright concerns, or assistance.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/contact/',
				},
			],
		},
		component: () => import('@/views/contact.vue'),
	},
	{
		path: '/tr/',
		name: 'tr-gb',
		props: { locale: 'tr' },
		meta: {
			appname: 'SnapInsta',
			lang: 'tr',
			dir: 'ltr',
			title: 'Snapinsta – Instagram Reels, Video, Story ve Fotoğraf İndir',
			keywords: 'snapinsta, instagram video indir, instagram reels indir, instagram fotoğraf indir',
			description: 'Instagram Reels, video, Story ve fotoğrafları SnapInsta ile ücretsiz ve kolayca indirin. Bağlantıyı yapıştırın, uygun indirme seçeneklerini görün.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/tr/',
				},
			],
		},
		component: () => import('@/views/localized-home.vue'),
	},
	{
		path: '/ar/',
		name: 'ar-gb',
		props: { locale: 'ar' },
		meta: {
			appname: 'SnapInsta',
			lang: 'ar',
			dir: 'ltr',
			title: 'Snapinsta – تنزيل فيديوهات إنستغرام وريلز وصور وستوري',
			keywords: 'snapinsta, تنزيل فيديو انستقرام, تنزيل ريلز انستقرام, تنزيل صور انستقرام',
			description: 'حمّل فيديوهات إنستغرام وريلز والصور والستوري مجانًا عبر SnapInsta. الصق الرابط واختر النسخة المتاحة للتنزيل بسهولة.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/ar/',
				},
			],
		},
		component: () => import('@/views/localized-home.vue'),
	},
	{
		path: '/hi/',
		name: 'hi-gb',
		props: { locale: 'hi' },
		meta: {
			appname: 'SnapInsta',
			lang: 'hi',
			dir: 'ltr',
			title: 'Snapinsta – Instagram Reels, Video, Story और Photo डाउनलोड करें',
			keywords: 'snapinsta, instagram video download hindi, instagram reels download, instagram photo download',
			description: 'SnapInsta से Instagram Reels, video, Story और photos आसानी से डाउनलोड करें। लिंक पेस्ट करें और उपलब्ध डाउनलोड विकल्प चुनें।',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/hi/',
				},
			],
		},
		component: () => import('@/views/localized-home.vue'),
	},
	{
		path: '/es/',
		name: 'es-gb',
		props: { locale: 'es' },
		meta: {
			appname: 'SnapInsta',
			lang: 'es',
			dir: 'ltr',
			title: 'Snapinsta – Descargar videos, Reels, Stories y fotos de Instagram',
			keywords: 'snapinsta, descargar video instagram, descargar reels instagram, descargar fotos instagram',
			description: 'Descarga videos, Reels, Stories y fotos públicas de Instagram con SnapInsta. Pega el enlace y elige el archivo disponible en unos segundos.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/es/',
				},
			],
		},
		component: () => import('@/views/localized-home.vue'),
	},
	{
		path: '/fr/',
		name: 'fr-gb',
		props: { locale: 'fr' },
		meta: {
			appname: 'SnapInsta',
			lang: 'fr',
			dir: 'ltr',
			title: 'Snapinsta – Télécharger vidéos, Reels, Stories et photos Instagram',
			keywords: 'snapinsta, telecharger video instagram, telecharger reels instagram, telecharger photos instagram',
			description: 'Téléchargez gratuitement des vidéos, Reels, Stories et photos Instagram avec SnapInsta. Collez le lien et choisissez le fichier disponible.',
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/fr/',
				},
			],
		},
		component: () => import('@/views/localized-home.vue'),
	},
	{
		path: '/id/',
		name: 'id-home',
		redirect: '/hi/',
	},
	{
		path: '/br/',
		name: 'br-home',
		meta: {
			appname: 'SnapInsta',
			title: `Snapinsta – Baixar Instagram Reels, Vídeo, Story, Foto Online`,
			keywords: 'snapinsta, snapinsta app, snapinsta download, snapinsta downloader, baixar video instagram',
			description: `Plataforma SnapInsta que permite baixar facilmente reels, vídeos, stories e fotos do Instagram com apenas alguns cliques`,
			link: [
				{
					rel: 'canonical',
					href: 'https://snapsinsta.com/br/'
				}
			]
		},
		component: () => import('@/views/br.vue'),
	},

]


let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
